<template>
  <div :class="{ 'd-flex justify-start justify-md-center': center }">
    <img
      src="@/assets/img/_src/wave-mini.svg"
      alt="Маленькая волнистая линия"
    />
  </div>
</template>

<script>
export default {
  name: "SmallWave",
  props: {
    center: Boolean
  }
};
</script>
